import { InvoiceTicket, InvoiceHeader, ConfirmationFormSection, BillingInfoSectionSlot as BillingInfoSection } from "../../common/components";
import { ClientSectionSlot } from "./ClientSectionSlot";

export { ClientSectionSlot as ClientSection, BillingInfoSection, InvoiceHeader as InvoiceHeaderSlot };
//************************************InvoiceForm.js slots************************************
/**
 * COMPONENTE SLOT PARA LA SECCIÓN "CONFIRMACION"
 * Se renderizará en onSubmit de la nueva factura para corroborar datos de facturacion
 */
export { ConfirmationFormSection };

/**
 * COMPONENTE SLOT PARA LA SECCIÓN "TICKET"
 * Se renderizará al confirmar factura.
 */
export const TicketSection = (props) => <InvoiceTicket {...props} />;